import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdminSelect from '../../../components/admin/admin-default-select';
import Loader from '../../../components/Loader';
import { addExistingDealer } from '../../../api/districtsiteuserapi';

export default function ExistingDealerModal({ show, onClose, excludedDealers, districtId, onDealerAdded }) {
    const [selectedDealer, setSelectedDealer] = useState('');
    const [loading, setLoading] = useState(false);

    if (!show) return null;

    const handleSave = async () => {
        if (!selectedDealer) return;
        setLoading(true);
        try {
            const response = await addExistingDealer(districtId, selectedDealer);
            if (response.data.success) setSelectedDealer('');
            onDealerAdded();
        } catch (err) {
            console.error('Error adding existing dealer:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                {loading ? <Loader /> : (
                    <>
                        <button className="admin-modal-close" onClick={onClose}>
                            <span className="material-symbols-rounded">close</span>
                        </button>
                        <h2 className="admin-modal-heading">Add Existing Dealer</h2>
                        <div className="admin-modal-row">
                            <div className="admin-modal-cell">
                                <AdminSelect
                                    id="existing-dealer-select"
                                    label="Select Dealer"
                                    value={selectedDealer}
                                    onChange={(val) => setSelectedDealer(val)}
                                    options={[
                                        { value: '', label: '[Select a Dealer]' },
                                        ...excludedDealers.map(dealer => ({
                                            value: dealer.siteUserId,
                                            label: `${dealer?.siteUsers?.fullName} (${dealer?.siteUsers?.email})`
                                        }))
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="admin-modal-button-wrap">
                            <button className="admin-modal-button" onClick={onClose}>Cancel</button>
                            <button className="admin-modal-button power" onClick={handleSave} disabled={!selectedDealer}>Save</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

ExistingDealerModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    excludedDealers: PropTypes.array.isRequired,
    districtId: PropTypes.string.isRequired,
    onDealerAdded: PropTypes.func.isRequired,
};
